import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useCart } from 'react-use-cart';
import { Icon } from '@iconify/react';
import Cart from '@iconify/icons-mdi/cart';

import Button from '~/components/modules/buttons/default';

import trackEvent from '~/hooks/useEventTracker';

const UpdateItemsForm = ({ product, className }) => {
	const { updateItemQuantity } = useCart();
	const [isComplete, setIsComplete] = useState(false);
	const availability = product.item.Availability.filter(
		availability => availability.data.Availability === product.availability
	)[0];

	const { register, handleSubmit } = useForm({
		mode: 'onSubmit'
	});

	const onSubmit = values => {
		if (values.quantity === product.quantity) {
			return;
		}
		setIsSubmitting(true);
		updateItemQuantity(values.id, parseInt(values.quantity));
		trackEvent('Cart', 'Update Quantity', product.sku, values.quantity);
		setIsSubmitting(false);
		setIsComplete(true);
		setTimeout(() => {
			setIsComplete(false);
		}, 2000);
	};

	const [isSubmitting, setIsSubmitting] = useState(false);

	return (
		<div className={className ?? ''}>
			<div className="bg-navigation-cartButton-icon-background text-navigation-cartButton-icon-color font-bold p-2 text-xs mb-2">
				{product.availability}
			</div>
			<form onSubmit={handleSubmit(onSubmit)} className="flex flex-row gap-2">
				<input
					{...register('quantity')}
					type="tel"
					autoComplete="off"
					className="w-3/5 border-gray-400 text-xs p-1"
					aria-required="false"
					disabled={isSubmitting}
					defaultValue={product.quantity}
					onFocus={e => e.target.setSelectionRange(0, e.target.value.length)}
				/>
				<input type="hidden" {...register('id')} value={product.id} />

				<Button
					as="button"
					type="submit"
					variant="secondary"
					size="sm"
					className="w-2/5 flex items-center justify-between !text-2xs !py-1.5"
				>
					{isComplete ? 'Updated!' : isSubmitting ? 'Updating..' : 'Update'}
					<Icon icon={Cart} height="1rem" width="1rem" className="w-3 h-3" />
				</Button>
			</form>
			{availability.data.Order_Review_Quantity &&
				availability.data.Order_Review_Quantity >= 0 &&
				product.quantity >= availability.data.Order_Review_Quantity && (
					<p className="bg-red-800 text-white py-1 px-2 text-xs mt-2">
						<span role="img" aria-label="warning">
							⚠️
						</span>{' '}
						Requesting{' '}
						<span className="font-bold">
							{availability.data.Order_Review_Quantity}
						</span>{' '}
						or more of this item will require your order to{' '}
						<span className="whitespace-nowrap">be reviewed.</span>
					</p>
				)}
		</div>
	);
};

export default UpdateItemsForm;
